module.exports = __webpack_public_path__ + "img/2.e76d77c7.jpg";